<template>
    <div>
        <div class="list-title">
            <h3>Configuración IMAP</h3>
        </div>

        <div class="search-bar">
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <v-flex xs12 md3>
                        <v-text-field class="lance" v-model="search.code" label="Código" @input="searchOnTable"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-text-field class="lance" v-model="search.name" label="Nombre" @input="searchOnTable"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-text-field class="lance" v-model="search.description" label="Descripción" @input="searchOnTable"></v-text-field>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-btn fab v-if="credentials.MailConfigurationCreate" color="primary" @click="goTo('MailConfigurationform')">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-layout>
            </v-container>
        </div>
        
        <v-data-table
            :headers="headers"
            :items="list"
            :loading="loading"
            class="table-catalog elevation-5">
            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" @click="goTo('MailConfigurationform/' + props.item.id)">
                <tr v-bind:class="{ itemToDelete: props.item.id == itemToDelete }"
                    class="cursor-pointer"
                    @click="credentials.MailConfigurationRead? goTo('MailConfigurationDetail/' + props.item.id): null">
                    <td class="text-xs-left">{{ props.item.code }}</td>
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">{{ props.item.description }}</td>
                    <td class="text-xs-right">
                        <v-btn fab small color="primary" 
                            v-if="credentials.MailConfigurationUpdate" 
                            @click.stop="goTo('MailConfigurationform/' + props.item.id)">
                            <img src="@/assets/icon-editar.svg" alt="">
                        </v-btn>
                        <v-btn fab small color="error" 
                            v-if="credentials.MailConfigurationDelete" 
                            @click.stop="confirmDelete(props.item.id)" 
                            :disabled="(currentUserId === props.item.id)">
                            <img src="@/assets/icon-eliminar.svg" alt="">
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template slot="no-data">
                No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.
            </template>
        </v-data-table>
        <v-dialog v-model="deleteDialog" max-width="350">
            <v-card>
                <v-card-title class="headline">Confirmación</v-card-title>
                <v-card-text>¿Está seguro de querer borrar este registro?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" flat @click="deleteDialog=false; itemToDelete = '';">Cancelar</v-btn>
                    <v-btn color="primary" flat @click="deleteDialog=false; deleteRegistry(itemToDelete)">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
    import { events, printList } from '../main';
    import _ from 'underscore';
    import moment from 'moment-timezone';

    export default {
        components: { 
        },
        data () {
            return {
                list: [],
                source: [],
                search: {
                    code: "",
                    name: "",
                    description: "",
                },
                headers: [
                    { text: 'Código', value: 'code' },
                    { text: 'Nombre', value: 'name' },
                    { text: 'Descripción', value: 'description' },
                    { text: '', value: 'delete', align: 'center', sortable: false, width: "200px" },
                ],
                loading: true,
                deleteDialog: false,
                itemToDelete: '',
                currentUserId: localStorage.getItem('userId'),
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
            }
        },
        methods: {
            snackbar: function(message) {
                events.$emit('snackbar', message);            
            },
            confirmDelete: function(id) {
                this.itemToDelete = id;
                this.deleteDialog = true;
            },
            goTo(url) {
                var self = this;
                self.$router.push('/' + url);
            },
            getList: function() {
                this.$http.get('MailConfiguration')
                    .then(response => {
                        var list = response.body;
                        this.list = list;
                        this.source = list;
                        this.loading = false;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista');
                        console.error(error);
                    })
            },
            deleteRegistry(id) {
                this.showConfirm = false;
                this.$http.delete('MailConfiguration/' + id)
                    .then(response => {
                        this.itemToDelete = '';
                        this.getList();
                        this.snackbar('El registro ha sido eliminado con éxito');
                    }, error => {
                        this.itemToDelete = '';
                        this.snackbar('Hubo un problema al eliminar el registro');
                        console.error(error);
                    });
            },
            searchOnTable: function() {
                this.list = _.filter(this.source, item => {
                    if (this.search.description === "" || this.search.description === null)
                        return item.code.toLowerCase().includes(this.search.code.toLowerCase())
                            && item.name.toLowerCase().includes(this.search.name.toLowerCase());
                    else {
                        return item.code.toLowerCase().includes(this.search.code.toLowerCase())
                            && item.name.toLowerCase().includes(this.search.name.toLowerCase())
                            && item.description !== null
                            && item.description.toLowerCase().includes(this.search.description.toLowerCase());
                    }
                });
            },
        },
        mounted() {
            this.getList();
        },
        filters: {
            moment: function (date) {
                return moment(date).locale("es").format('LL');
            }
        },
    }
</script>